import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loading = ({ show }) => {
  return (
    <div className={`loading ${show ? "show" : ""}`}>
      <CircularProgress />
    </div>
  );
};

export default Loading;
